import * as axios from 'axios'

const url = `${process.env.VUE_APP_API_URL}/account`

export const removeAccount = () => {
    return axios.default.delete(`${url}/remove`)
}